

import React, { useState } from 'react';
import axios from 'axios';
import { AppConstants } from '../../constants/AppConstants';
import authHeader from '../../services/AuthHeader';

const ImportDeliveries: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploadMessage, setUploadMessage] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(AppConstants.API_URL + "/deliveries/import-delivery", formData, {
        headers: {
          ...authHeader(),
          "Content-Type": "multipart/form-data",
        }, 
      });
      setUploadMessage("Upload successful!");
    } catch (err) {
      setUploadMessage("Upload failed.");
    }
  };

  return (
    <div className="card p-4">
      <h3>Import Deliveries (CSV or Excel)</h3>
      <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={handleFileChange} />
      <button onClick={handleUpload} className="btn btn-primary mt-2">Upload</button>
      {uploadMessage && <p>{uploadMessage}</p>}
    </div>
  );
};

export default ImportDeliveries;